import styled from '@emotion/styled';

export const Sticky = styled.div`
  z-index: 99;
  width: calc(100% - 94px);
`;
